// YERİ: src/app/domains/site/sections/team.section.ts
// Ekibimiz — avukat kartları (foto + ad + unvan + uzmanlık).

import { inject, Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';

interface Member { name: string; role?: string; specialty?: string; imageUrl?: string; }

@Component({
  selector: 'sec-team',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="team" class="bg-neutral-50 py-24 dark:bg-neutral-900">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
          @if (subtitle()) { <p class="mt-4 text-lg text-neutral-600 dark:text-neutral-400">{{ subtitle() }}</p> }
        </div>
        <div class="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          @for (m of members(); track m.name) {
            <div class="group overflow-hidden rounded-2xl border border-neutral-200 bg-white text-center transition hover:shadow-xl dark:border-neutral-800 dark:bg-neutral-950">
              <div class="aspect-square w-full overflow-hidden">
                @if (m.imageUrl) {
                  <img [src]="m.imageUrl" [alt]="m.name" class="h-full w-full object-cover transition group-hover:scale-105" />
                } @else {
                  <div class="flex h-full w-full items-center justify-center" style="background:linear-gradient(135deg,var(--site-primary),var(--site-primary-dark))">
                    <m-icon name="user" class="!size-20 text-white/40" />
                  </div>
                }
              </div>
              <div class="p-6">
                <h3 class="text-lg font-semibold text-neutral-900 dark:text-white">{{ m.name }}</h3>
                @if (m.role) { <p class="mt-1 text-sm font-medium" style="color:var(--site-accent)">{{ m.role }}</p> }
                @if (m.specialty) { <p class="mt-2 text-sm text-neutral-500">{{ m.specialty }}</p> }
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class TeamSection {
  protected text = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', 'Kadromuz'));
  protected title = computed(() => cfg(this.config(), 'title', this.text.t('fb.avukatlarimiz')));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', this.text.t('fb.alanindaUzmanCozumOdakli')));
  protected members = computed<Member[]>(() => cfg<Member[]>(this.config(), 'members', [
    { name: 'Av. Mehmet Yılmaz', role: 'Kurucu Ortak', specialty: this.text.t('fb.ticaretSirketlerHukuku') },
    { name: 'Av. Elif Demir', role: 'Ortak', specialty: 'Aile & Miras Hukuku' },
    { name: 'Av. Can Aydın', role: 'Avukat', specialty: 'Ceza Hukuku' },
  ]));
}
